export default __webpack_public_path__ + "static/media/me.26ce9596.png";